// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_15CV6","visuallyhidden":"_2rT0b","hide-text":"_2GtT6","center":"_23mh_","noprint":"_1KaKs","videoRatio":"_1RbWO","square":"_3skHG","audio":"QQz2v","video-paywall-overlay":"_2NKln","top":"_21J6O","play-button":"_205YZ","info-message":"iLcV9"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-video-paywall-overlay/styles/default.scss
 ** module id = 1027
 ** module chunks = 2
 **/